/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initBestsellers(sectionId) {
  var $section = $('.bestsellers-' + sectionId);
  if (!$section.length) return;

  var $swiperEl = $section.find('.js-bestsellers-slider-swiper-' + sectionId);
  var $prevBtn  = $section.find('.js-bestsellers-slider-prev-' + sectionId);
  var $nextBtn  = $section.find('.js-bestsellers-slider-next-' + sectionId);
  var $tabs     = $section.find('.bestsellers__tab');
  var $wrapper  = $swiperEl.length ? $swiperEl.find('.swiper-wrapper') : $();

  if (!$swiperEl.length || !$wrapper.length) return;

  var allSlideData = [];
  $wrapper.find('.bestsellers__slide').each(function() {
    allSlideData.push({
      el: this,
      collection: $(this).attr('data-collection') || ''
    });
  });

  var srDone = false;

  function revealSlides(elements) {
    if ($(window).width() <= 799) {
      showSlidesInstantly(elements);
      return;
    }
    if (typeof ScrollReveal === 'undefined') {
      showSlidesInstantly(elements);
      return;
    }

    $.each(elements, function(i, el) {
      ScrollReveal().reveal(el, {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0 + (i * 40),
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true,
        afterReveal: function(el) {
          $(el).css({ visibility: '', opacity: '', transform: '' });
          ScrollReveal().clean(el);
        }
      });
    });
  }

  function showSlidesInstantly(elements) {
    $.each(elements, function(_, el) {
      if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(el);
      $(el).css({ visibility: 'visible', opacity: 1, transform: 'none' });
    });
  }

  function applyTab(target) {
    $.each(allSlideData, function(_, item) {
      $(item.el).detach();
    });

    var appended = [];
    $.each(allSlideData, function(_, item) {
      if (target === 'all' || item.collection === target) {
        $wrapper.append(item.el);
        appended.push(item.el);
      }
    });

    return appended;
  }

  var $activeTab = $tabs.filter('.is-active');
  var initialTarget = $activeTab.length ? $activeTab.attr('data-tab') : 'all';
  var initialSlides = applyTab(initialTarget);

  var swiper = new Swiper($swiperEl[0], {
    slidesPerView: 'auto',
    spaceBetween: 16,
     grabCursor: true,
  speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 3,
    followFinger: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    nested: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      sticky: false,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
    navigation: { prevEl: $prevBtn[0], nextEl: $nextBtn[0] },
    breakpoints: {
      1279: { spaceBetween: 20 }
    },
    on: {
      slideChange: function() {
        if ($(window).width() <= 799) return;
        var swiper = this;
        $(swiper.slides).each(function(i, slide) {
          if ($(slide).css('opacity') === '0') {
            $(slide).css({
              transition: 'none',
              opacity: 1,
              transform: 'translateY(0)',
              visibility: 'visible'
            });
            if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(slide);
          }
        });
      }
    }
  });

  setTimeout(function() {
    revealSlides(initialSlides);
    srDone = true;
  }, 50);

  if (typeof ScrollReveal !== 'undefined' && $(window).width() > 799) {
    ScrollReveal().reveal('.bestsellers-' + sectionId + ' .bestsellers__title', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    ScrollReveal().reveal('.bestsellers-' + sectionId + ' .bestsellers__controls', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      interval: 40,
      once: true
    });

    ScrollReveal().reveal('.bestsellers-' + sectionId + ' .bestsellers__nav', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      interval: 40,
      once: true
    });
  }

  if (!$tabs.length) return;

  $tabs.on('click', function() {
    $tabs.removeClass('is-active').attr('aria-selected', 'false');
    $(this).addClass('is-active').attr('aria-selected', 'true');

    var target = $(this).attr('data-tab');
    var appended = applyTab(target);

    swiper.update();
    swiper.slideTo(0, 0);
    if (swiper.navigation) swiper.navigation.update();

    showSlidesInstantly(appended);
  });
}

$(function() {
  var instances = window.DeskBestsellers || {};
  $.each(instances, function(id) {
    initBestsellers(id);
  });
});